import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { savedMessagesActions } from '../../actions';
import { FetchSavedMessagesActionPayload } from '@bus/savedMessages/typedefs';

export function* fetchSavedProjects() {
  try {
    yield effects.put(savedMessagesActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'saved-messages/projects' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: FetchSavedMessagesActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(savedMessagesActions.fillSavedProjects(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(savedMessagesActions.stopFetching());
  }
}
